
















































































































import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import MainTitle from '@/components/common/MainTitle.vue';
import MainParagraph from '@/components/common/MainParagraph.vue';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    MainTitle,
    MainParagraph,
  },
  metaInfo(this: Enterprise): MetaInfo {
    return {
      title: 'Join Us |',
      meta: [
        ...seoDefault({
          title: 'Join Us | Mysoalan',
          description:
            'We are passionate people that want to help all teachers out there to prepare paper exams for any subject. So that teachers can focus more on teaching instead of hassling drafting exam papers while meeting the deadline.',
        }),
      ],
    };
  },
})
export default class Enterprise extends Vue {
  mainTitle = [
    {
      type: 'normal',
      value: 'Join us to',
    },
    {
      type: 'highlight',
      value: 'grow',
    },
    {
      type: 'normal',
      value: 'your business',
    },
  ];

  mainP = `Transform the way you work with our question bank and everything you need to get stuff done.`;

  secondTitle = [
    {
      type: 'normal',
      value: 'Built to',
    },
    {
      type: 'highlight',
      value: 'solve',
    },
    {
      type: 'normal',
      value: 'your problem',
    },
  ];

  secondP = `Why choose Mysoalan? Mysoalan solve your problem with exam papers.`;

  secondItems = [
    {
      title: 'Unlimited question bank',
      image: require('@/assets/icon/ic_infinity_v2.svg'),
      imageSize: '50',
      description: `Get unlimited access to over a thousand questions for all different subjects.`,
    },
    {
      title: 'Save your time',
      image: require('@/assets/icon/ic_clock.svg'),
      imageSize: '40',
      description: `Now you can focus on the things that really matter and not spend your precious time on technical issues.`,
    },
    {
      title: 'Accessible anytime, anywhere',
      image: require('@/assets/icon/ic_devices.svg'),
      imageSize: '40',
      description: `Create and access your questions using laptop or any mobile device anytime and anywhere.`,
    },
  ];

  thirdTitle = [
    {
      type: 'normal',
      value: 'A',
    },
    {
      type: 'highlight',
      value: 'solution',
    },
    {
      type: 'normal',
      value: ' to solve all your problems',
    },
  ];

  thirdP = `With all these tools, you can start focusing on what really matters.`;

  thridItems = [
    {
      title: 'Add your own questions',
      image: require('@/assets/icon/ic_paper_stack.svg'),
      imageSize: '40',
      description: `Do you have your own sets of questions to add to the paper? Upload them here.`,
    },
    {
      title: 'White labelling',
      image: require('@/assets/icon/ic_tuition.svg'),
      imageSize: '46',
      description: `We will provide your own portal for you which would have exclusive questions just for your company.`,
    },
    {
      title: 'Customizable Questions',
      image: require('@/assets/icon/ic_customize.svg'),
      imageSize: '50',
      description: `Mysoalan offers customizable questions to help businesses develop their own question bank.`,
    },
    {
      title: 'Generate PDF',
      image: require('@/assets/icon/ic_pdf_v2.svg'),
      imageSize: '50',
      description: `Mysoalan offers a PDF generator for exam papers so you can easily create and share PDF versions.`,
    },
    {
      title: 'Browsing and filtering questions',
      image: require('@/assets/icon/ic_search_filter.svg'),
      imageSize: '46',
      description: `With an easy-to-use browsing and filtering system, you can quickly find the question you need.`,
    },
    {
      title: 'Supports and help',
      image: require('@/assets/icon/ic_collab.svg'),
      imageSize: '46',
      description: `Need support? We are here for you. We offer various digital solutions & customization for education.`,
    },
  ];
}
